/**
 * названия для проходов
 */

export const passWaysNames = {
    PASS_WAYS_TYPE: 'pass_ways_layer',
    GROUP_NAME: 'pass_ways',
};
